// extracted by mini-css-extract-plugin
module.exports = {"landingPage":"LandingPage_landingPage__1ZhmZ","cross":"LandingPage_cross__38npz","content":"LandingPage_content__2hi4F"};